import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationLogDocument } from 'modules/accommodations/features/reservations/api';

export const useCalculationLogDocumentQuery = (calculationId: string, logId: string) => {
  const { error, data, isLoading } = useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_LOG_DOCUMENT, calculationId, logId],
    () => getCalculationLogDocument(calculationId, logId),
    { keepPreviousData: true, staleTime: 5 * 60 * 1000 }, //5 minutes
  );

  return {
    error,
    isLoading,
    data,
  };
};
